import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/** global EAS  PTTSendClick mq*/

/* eslint-disable new-cap */
import { isFunction } from '../../common/base';
import util from '../../common/util';
import miloRequest from '../../common/network';
var shareApi = "".concat(location.protocol, "//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152");
var defaultOpts = {
  title: document.title,
  // 分享标题，默认为活动页面标题（可手动调整）
  desc: '',
  // 分享活动简介
  shareType: '',
  // 分享（0,1,2,3）类型
  link: '',
  // 分享链接
  imageUrl: '',
  // 分享后朋友看到的图标
  QQcallback: '',
  // qq分享后的回调方法
  QQtrigger: '',
  // qq触发事件的回调
  curShareType: 0 // 记录当前分享类型

};

var shareAll = function shareAll(opts, mqq) {
  // const url = encodeURIComponent(document.location.href);
  console.log('opts', opts);
  var curShareType = opts.curShareType,
      imageUrl = opts.imageUrl;
  var title = opts.title,
      desc = opts.desc,
      _opts$link = opts.link,
      link = _opts$link === void 0 ? location.href : _opts$link;
  var backupLink = link; // let { link } = opts;
  // if (curShareType == 2 && curShareType == 3) {
  //   link = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${link}&response_type=code&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
  // }
  // 手QAPI文档：http://mqq.oa.com/api.html#js-mqq-ui-shareMessage
  // title 必填，消息标题，最长45字节
  // desc  必填，消息摘要，最长60字节
  // share_url 必填，点击消息后的跳转url，最长120字节。原 targetUrl 参数，可以继续使用 targetUrl
  // image_url 必填，消息左侧缩略图url。图片推荐使用正方形，宽高不够时等比例撑满，不会变形。原 imageUrl 参数，可以继续使用 imageUrl。注意：图片最小需要200 * 200，否则分享到Qzone时会被Qzone过滤掉。

  if (util.getCharLength(title) >= 45) {
    console.log("\u8BBE\u7F6E\u7684\u5206\u4EAB\u6807\u9898title\u8D85\u8FC7\u624BQ\u9650\u523645\u5B57\u8282\uFF0C\u539F\u59CB\u53C2\u6570\uFF1A".concat(title, "\uFF0C\u5F53\u524D\u5B57\u8282\u6570\uFF1A").concat(util.getCharLength(title)));
    title = util.splitStringByCharLength(title, 45);
    console.log("\u6807\u9898\u5DF2\u81EA\u52A8\u5207\u5272\u4E3A\uFF1A".concat(title));
  }

  if (util.getCharLength(desc) >= 60) {
    console.log("\u8BBE\u7F6E\u7684\u5206\u4EAB\u63CF\u8FF0desc\u8D85\u8FC7\u624BQ\u9650\u523660\u5B57\u8282\uFF0C\u539F\u59CB\u53C2\u6570\uFF1A".concat(desc, "\uFF0C\u5F53\u524D\u5B57\u8282\u6570\uFF1A").concat(util.getCharLength(desc)));
    desc = util.splitStringByCharLength(desc, 60);
    console.log("\u63CF\u8FF0\u5DF2\u81EA\u52A8\u5207\u5272\u4E3A\uFF1A".concat(desc));
  }

  if (util.getCharLength(link) >= 120) {
    // 如果超过渠道限制的长度，砍掉参数
    console.log("\u8BBE\u7F6E\u7684\u5206\u4EAB\u5730\u5740share_url\u8D85\u8FC7\u624BQ\u9650\u5236120\u5B57\u8282\uFF0C\u539F\u59CB\u53C2\u6570\uFF1A".concat(link, "\uFF0C\u5F53\u524D\u5B57\u8282\u6570\uFF1A").concat(util.getCharLength(link)));
    link = link.split('?')[0];
    link = link.split('#')[0]; // 如果砍掉了还是长，恢复成原来的，放弃治疗了

    if (util.getCharLength(link) >= 120) {
      link = backupLink;
      console.log('当前地址不支持自动切割，请重新配置分享地址，建议删除不必要的get参数或考虑使用短链接！');
    } else {
      console.log("\u5730\u5740\u5DF2\u81EA\u52A8\u4FEE\u6539\u4E3A\u5207\u5272\u53C2\u6570\u540E\u8DEF\u5F84\uFF1A".concat(link));
    }
  }

  mqq.ui.shareMessage({
    title: title,
    desc: desc,
    share_type: curShareType,
    share_url: link,
    image_url: imageUrl,
    back: true // 分享之后返回webview

  }, function (result) {
    if (isFunction(opts.QQcallback)) {
      opts.QQcallback(result);
    } // EAS上报


    if (window.EAS && isFunction(EAS.SendClick)) {
      if (0 == result.retCode) {
        EAS.SendClick({
          e_c: "share.qq_".concat(curShareType, ".end"),
          c_t: 4
        });
      } else if (1 == result.retCode) {
        EAS.SendClick({
          e_c: "share.qq_".concat(curShareType, ".cancel"),
          c_t: 4
        });
      }
    } // PTT上报


    if (window.PTTSendClick && isFunction(window.PTTSendClick)) {
      if (0 == result.retCode) {
        0 == curShareType && PTTSendClick('share', 'qq_success', '从QQ分享至QQ好友成功');
        1 == curShareType && PTTSendClick('share', 'qzone_success', '从QQ分享至QQ空间成功');
      } else if (1 == result.retCode) {
        0 == curShareType && PTTSendClick('share', 'qq_cancel', '从QQ分享至QQ好友取消');
        1 == curShareType && PTTSendClick('share', 'qzone_cancel', '从QQ分享至QQ空间取消');
      }
    }
  });
}; // 手q初始化


export default function (opt) {
  var opts = _objectSpread(_objectSpread({}, defaultOpts), opt); // 修复mqq下分享失败 by weiztang 20210826


  var setShareInfo = function setShareInfo() {
    console.log('mqq setShareInfo', opts);

    if ((typeof mqq === "undefined" ? "undefined" : _typeof(mqq)) === 'object') {
      mqq.ui.setOnShareHandler(function (type) {
        // 0：QQ好友
        // 1：QQ空间
        // 2：微信好友
        // 3：微信朋友圈
        opts.curShareType = type;

        if (isFunction(opts.QQtrigger)) {
          opts.QQtrigger(type);
        }

        if (window.EAS && isFunction(EAS.SendClick)) {
          EAS.SendClick({
            e_c: "share.qq_".concat(opts.curShareType, ".start"),
            c_t: 4
          });
        } // 微信只上报行为，不区分成功与否


        if (window.PTTSendClick && isFunction(window.PTTSendClick)) {
          3 == type && PTTSendClick('share', 'timeline_success', '从QQ分享至朋友圈成功');
          2 == type && PTTSendClick('share', 'message_success', '从QQ分享至微信好友成功');
        }

        console.log('setOnShareHandler', opts);
        shareAll(opts, mqq);
      });
    }
  };

  try {
    if ((typeof mqq === "undefined" ? "undefined" : _typeof(mqq)) !== 'object') {
      miloRequest.getScript(shareApi).then(function () {
        setShareInfo();
      });
    } else {
      setShareInfo();
    }
  } catch (e) {
    console.log(e);
  }
}